module.exports = __webpack_public_path__ + "static/img/国元证券.17af85c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/国元证券.png
// module id = wbfP
// module chunks = 3